<template>
  <topHeader />
  <div class="top-search">
    <div class="container">
      <!-- 搜索区域 -->
      <div class="search-section">
        <div class="search-bar">
          <div class="search-input-group">
            <span class="iconfont icon-sousuo"></span>
            <input 
              type="text" 
              placeholder="输入土方关键词,例如,砂砾坚土"
              class="search-input"
              v-model="searchKeyword"
              @keyup.enter="performSearch"
            />
            <button class="search-btn" @click="performSearch">搜索</button>
          </div>
        </div>
        
        <!-- 搜索关键词标签 -->
        <div class="search-tags">
          <span class="tag-label">热门搜索:</span>
          <span class="search-tag" v-for="tag in hotTags" :key="tag" @click="searchByTag(tag)">{{ tag }}</span>
        </div>
      </div>

      <!-- 筛选条件 -->
      <div class="filter-section">
        <div class="filter-tabs">
          <span class="filter-tab" :class="{ active: activeFilter === 'all' }" @click="setFilter('all')">全部</span>
          <span class="filter-tab" :class="{ active: activeFilter === 'supply' }" @click="setFilter('supply')">供应</span>
          <span class="filter-tab" :class="{ active: activeFilter === 'demand' }" @click="setFilter('demand')">需求</span>
          <span class="filter-tab" :class="{ active: activeFilter === 'transport' }" @click="setFilter('transport')">运输</span>
        </div>
        
        <div class="filter-options">
          <select class="filter-select" v-model="selectedRegion">
            <option value="">选择地区</option>
            <option value="qinhuangdao">全秦皇岛</option>
            <option value="haigang">海港区</option>
            <option value="kaifa">开发区</option>
            <option value="funing">抚宁区</option>
            <option value="shanhaiguan">山海关区</option>
          </select>
          
          <select class="filter-select" v-model="selectedType">
            <option value="">选择土方类型</option>
            <option value="songruan">松软土</option>
            <option value="putong">普通土</option>
            <option value="jian">坚土</option>
            <option value="shali">砂砾坚土</option>
            <option value="huitu">回填土</option>
          </select>
          
          <select class="filter-select" v-model="selectedArea">
            <option value="">选择体积</option>
            <option value="small">10立方以下</option>
            <option value="medium">10-50立方</option>
            <option value="large">50-100立方</option>
            <option value="xlarge">100立方以上</option>
          </select>
          
          <button class="filter-btn" @click="applyFilters">筛选</button>
        </div>
      </div>

      <!-- 搜索结果统计 -->
      <div class="result-stats">
        <span class="stats-text">找到 <strong>{{ filteredProducts.length }}</strong> 个相关结果</span>
        <div class="sort-options">
          <span class="sort-label">排序:</span>
          <span class="sort-option" :class="{ active: sortBy === 'time' }" @click="setSort('time')">最新发布</span>
          <span class="sort-option" :class="{ active: sortBy === 'price' }" @click="setSort('price')">价格</span>
          <span class="sort-option" :class="{ active: sortBy === 'distance' }" @click="setSort('distance')">距离</span>
        </div>
      </div>

      <!-- 商品列表 -->
      <div class="products-section">
        <div class="products-grid">
          <div class="product-card" v-for="(product, index) in filteredProducts" :key="index" @click="goToProduct(index)">
            <div class="product-image">
              <img :src="product.image" alt="产品图片" class="product-img">
              <div class="product-tags">
                <span class="tag new-tag" v-if="product.isNew">新发布</span>
                <span class="tag transport-tag" v-if="product.hasTransport">包运输</span>
              </div>
            </div>
            <div class="product-info">
              <h3 class="product-title">{{ product.title }}</h3>
              <div class="product-attributes">
                <span class="attribute">{{ product.type }}</span>
                <span class="attribute">{{ product.material }}</span>
              </div>
              <div class="price-section">
                <div class="product-price">¥{{ product.price }}</div>
                <div class="product-volume">{{ product.volume }}</div>
              </div>
              <div class="product-location">
                <span class="iconfont icon-address"></span>
                {{ product.location }}
              </div>
              <div class="product-shipping">
                <span class="shipping-info">{{ product.shipping }}</span>
              </div>
              <div class="store-info">
                <span class="store-name">{{ product.storeName }}</span>
                <span class="store-customers">{{ product.customers }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <button class="page-btn" :disabled="currentPage === 1" @click="prevPage">上一页</button>
        <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
        <button class="page-btn" :disabled="currentPage === totalPages" @click="nextPage">下一页</button>
      </div>
    </div>
  </div>
  <Footer />
</template>

<script>
import TopHeader from './top-Header.vue'
import Footer from './Footer.vue'

export default {
  name: 'topSearch',
  components: {
    TopHeader,
    Footer
  },
  data() {
    return {
      searchKeyword: '',
      activeFilter: 'all',
      selectedRegion: '',
      selectedType: '',
      selectedArea: '',
      sortBy: 'time',
      currentPage: 1,
      itemsPerPage: 12,
      
      hotTags: ['松软土', '转让', '收购', '坚土', '回填土方', '砂砾坚土'],
      
      products: [
        {
          image: require('@/assets/sjt/1.png'),
          title: '海港区优质松软土供应 适合园林绿化工程',
          type: '松软土',
          material: '优质土壤',
          price: '30000.00',
          volume: '30m³',
          location: '海港区生态谷小区北侧',
          shipping: '包邮',
          storeName: '秦土平台旗舰店',
          customers: '回头客2万',
          isNew: true,
          hasTransport: true
        },
        {
          image: require('@/assets/sjt/2.png'),
          title: '开发区砂砾坚土转让 质量保证',
          type: '砂砾坚土',
          material: '混合土质',
          price: '25000.00',
          volume: '50m³',
          location: '开发区工业园',
          shipping: '包邮',
          storeName: '土方交易中心',
          customers: '回头客4万',
          isNew: false,
          hasTransport: true
        },
        {
          image: require('@/assets/sjt/3.png'),
          title: '抚宁区回填土方需求 长期合作',
          type: '回填土',
          material: '标准土质',
          price: '28000.00',
          volume: '40m³',
          location: '抚宁区建设工地',
          shipping: '包邮',
          storeName: '建设材料供应商',
          customers: '回头客7千',
          isNew: true,
          hasTransport: false
        },
        {
          image: require('@/assets/sjt/4.png'),
          title: '山海关区普通土供应 价格优惠',
          type: '普通土',
          material: '天然土壤',
          price: '22000.00',
          volume: '60m³',
          location: '山海关区农田',
          shipping: '包邮',
          storeName: '农田土方交易',
          customers: '回头客5万',
          isNew: false,
          hasTransport: true
        },
        {
          image: require('@/assets/sjt/5.png'),
          title: '青龙县坚土收购 量大从优',
          type: '坚土',
          material: '硬质土壤',
          price: '35000.00',
          volume: '25m³',
          location: '青龙县山区',
          shipping: '包邮',
          storeName: '山区土方专营',
          customers: '回头客3万',
          isNew: true,
          hasTransport: true
        },
        {
          image: require('@/assets/sjt/6.png'),
          title: '卢龙县外运土方 运输便捷',
          type: '外运土方',
          material: '混合土质',
          price: '32000.00',
          volume: '35m³',
          location: '卢龙县物流园',
          shipping: '包邮',
          storeName: '物流土方中心',
          customers: '回头客6千',
          isNew: false,
          hasTransport: true
        },
        {
          image: require('@/assets/sjt/7.png'),
          title: '昌黎县借方土供应 质量可靠',
          type: '借方土',
          material: '优质土质',
          price: '29000.00',
          volume: '45m³',
          location: '昌黎县开发区',
          shipping: '包邮',
          storeName: '开发区土方站',
          customers: '回头客8千',
          isNew: true,
          hasTransport: false
        },
        {
          image: require('@/assets/sjt/8.png'),
          title: '全秦皇岛常规土方 一站式服务',
          type: '常规土方',
          material: '标准土质',
          price: '26000.00',
          volume: '55m³',
          location: '秦皇岛全市',
          shipping: '包邮',
          storeName: '全市土方服务',
          customers: '回头客1万',
          isNew: false,
          hasTransport: true
        }
      ]
    }
  },
  computed: {
    filteredProducts() {
      let filtered = [...this.products];
      
      // 根据搜索关键词过滤
      if (this.searchKeyword) {
        filtered = filtered.filter(product => 
          product.title.includes(this.searchKeyword) ||
          product.type.includes(this.searchKeyword)
        );
      }
      
      // 根据筛选条件过滤
      if (this.selectedRegion) {
        filtered = filtered.filter(product => 
          product.location.includes(this.getRegionName(this.selectedRegion))
        );
      }
      
      if (this.selectedType) {
        filtered = filtered.filter(product => 
          product.type.includes(this.getTypeName(this.selectedType))
        );
      }
      
      // 排序
      if (this.sortBy === 'price') {
        filtered.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
      } else if (this.sortBy === 'time') {
        filtered.sort((a, b) => b.isNew - a.isNew);
      }
      
      return filtered;
    },
    
    totalPages() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    }
  },
  methods: {
    performSearch() {
      console.log('搜索关键词:', this.searchKeyword);
    },
    
    searchByTag(tag) {
      this.searchKeyword = tag;
      this.performSearch();
    },
    
    setFilter(filter) {
      this.activeFilter = filter;
    },
    
    applyFilters() {
      console.log('应用筛选条件:', {
        region: this.selectedRegion,
        type: this.selectedType,
        area: this.selectedArea
      });
    },
    
    setSort(sort) {
      this.sortBy = sort;
    },
    
    goToProduct(index) {
      this.$router.push(`/product/${index}`);
    },
    
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    
    getRegionName(value) {
      const regionMap = {
        'qinhuangdao': '秦皇岛',
        'haigang': '海港区',
        'kaifa': '开发区',
        'funing': '抚宁区',
        'shanhaiguan': '山海关区'
      };
      return regionMap[value] || '';
    },
    
    getTypeName(value) {
      const typeMap = {
        'songruan': '松软土',
        'putong': '普通土',
        'jian': '坚土',
        'shali': '砂砾坚土',
        'huitu': '回填土'
      };
      return typeMap[value] || '';
    }
  }
}
</script>

<style scoped>
/* 引入iconfont.css */
@import url('../assets/iconfont.css');

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f5f5f5;
  min-height: 100vh;
}

/* 搜索区域 */
.search-section {
  background: white;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.search-bar {
  margin-bottom: 20px;
}

.search-input-group {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
}

.search-input-group .iconfont {
  padding: 0 15px;
  color: #999;
  font-size: 16px;
}

.search-input {
  flex: 1;
  padding: 15px;
  border: none;
  outline: none;
  font-size: 16px;
}

.search-btn {
  padding: 15px 30px;
  background: #422C27;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.search-btn:hover {
  background: #0d6b5f;
}

.search-tags {
  display: flex;
  align-items: center;
  gap: 15px;
}

.tag-label {
  color: #666;
  font-size: 14px;
}

.search-tag {
  padding: 5px 12px;
  background: #f0f0f0;
  border-radius: 15px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s;
}

.search-tag:hover {
  background: #422C27;
  color: white;
}

/* 筛选区域 */
.filter-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.filter-tabs {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.filter-tab {
  padding: 10px 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.filter-tab.active {
  background: #422C27;
  color: white;
  border-color: #422C27;
}

.filter-options {
  display: flex;
  gap: 15px;
  align-items: center;
}

.filter-select {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.filter-btn {
  padding: 10px 20px;
  background: #422C27;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* 结果统计 */
.result-stats {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.stats-text {
  font-size: 14px;
  color: #666;
}

.sort-options {
  display: flex;
  gap: 15px;
  align-items: center;
}

.sort-label {
  font-size: 14px;
  color: #666;
}

.sort-option {
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
}

.sort-option.active {
  color: #422C27;
  font-weight: bold;
}

/* 商品网格 */
.products-section {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.product-card {
  border: 1px solid #eee;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s, box-shadow 0.3s;
  cursor: pointer;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
}

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-tags {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  gap: 5px;
}

.tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
}

.new-tag {
  background: rgba(255, 161, 0, 0.2);
  color: #FF7B00;
  border: 1px solid rgba(255, 123, 0, 0.5);
}

.transport-tag {
  background: rgba(0, 113, 215, 0.2);
  color: #0071D7;
  border: 1px solid rgba(0, 113, 215, 0.5);
}

.product-info {
  padding: 15px;
}

.product-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0 0 10px 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-attributes {
  display: flex;
  gap: 8px;
  margin-bottom: 10px;
}

.attribute {
  padding: 2px 6px;
  background: #f0f0f0;
  border-radius: 3px;
  font-size: 12px;
  color: #666;
}

.price-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.product-price {
  color: #422C27;
  font-size: 24px;
  font-weight: bold;
}

.product-volume {
  color: #999;
  font-size: 14px;
}

.product-location {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #666;
  font-size: 14px;
  margin-bottom: 8px;
}

.product-shipping {
  margin-bottom: 8px;
}

.shipping-info {
  color: #422C27;
  font-size: 12px;
}

.store-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #999;
}

.store-name {
  font-weight: bold;
}

/* 分页 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.page-btn {
  padding: 10px 20px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 4px;
  cursor: pointer;
}

.page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.page-btn:hover:not(:disabled) {
  background: #422C27;
  color: white;
  border-color: #422C27;
}

.page-info {
  font-size: 14px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .products-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .products-grid {
    grid-template-columns: 1fr;
  }
  
  .filter-options {
    flex-direction: column;
    align-items: stretch;
  }
  
  .result-stats {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
}
</style>